<template>
  <div class="resumeboxs">
    <div class="cont-top com-model flex flex-column align-initial flex-between">
      <div class="cont-title ccc">
        简历管理
        <input type="password" style="display: none; opacity: 0; height: 0; padding: 0;"/>
        <el-input placeholder="请输入姓名" v-model="keyword" class="input-with-select" clearable>
          <template slot="append"><i class="el-icon-search" @click="search"/></template>
        </el-input>
      </div>
      <el-tabs class="ac-tabs" v-model="tabName" @tab-click="handleClick">
        <el-tab-pane :label="item.name" :name='item.name' v-for="item in tabList" :key="item.id"/>
      </el-tabs>
    </div>
    <div style="margin-top: 4px">
      <div class="com-model" style="padding: 24px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;">
        <template v-if="pageTotal">
          <template v-if="checkList.length > 0">
            <div class="checked-all-box" v-show="rowList.length">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                全选
              </el-checkbox>
              <el-button type="primary"
                         plain
                         v-for="btn in checkList"
                         :key="btn"
                         @click="handleBatch(btn)"
                         :disabled="!checkedIdList.length">
                {{ btn }}
              </el-button>
            </div>
            <el-checkbox-group class="c-el-checkbox" v-model="checkedIdList" @change="handleCheckedidList">
              <el-checkbox :label="item.id" v-for="item in rowList" :key="item.id">
                <resume-item @qppRejectInterview="qppRejectInterview"
                             @appInterview="appInterview"
                             @interviewPass="interviewPass"
                             @failPost="failPost"
                             @successPost="successPost"
                             @deleteInterview="deleteInterview"
                             @interviewReject="interviewReject"
                             @qppCollWorkerInterview="qppCollWorkerInterview"
                             @downloadResume="downloadResume"
                             :item="item" :key="item.id" :tabindex="tabindex"/>
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-else>
            <resume-item @qppRejectInterview="qppRejectInterview"
                         @appInterview="appInterview"
                         @interviewPass="interviewPass"
                         @failPost="failPost"
                         @successPost="successPost"
                         @deleteInterview="deleteInterview"
                         @interviewReject="interviewReject"
                         @appInterviewSuccess="appInterviewSuccess"
                         @interviewFailView="interviewFailView"
                         v-for="(item, index) in rowList" :item="item" :key="item.id" :tabindex="tabindex"
                         :index="index"/>
          </template>
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="pageNum"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pageTotal"/>
          <new-confirm :visible.sync="showAddResume"
                       :name="addResumeName"
                       :workerId="addResumeId"
                       :recruitId="addResumeRecruitId"
                       v-if="showAddResume"/>
        </template>
        <template v-else>
          <no-data/>
        </template>
      </div>
    </div>
    <div class="modal" :class="{fadeIn:isModalShow,fadeOut:!isModalShow}" v-if="isModalShow">
      <div class="modal-mask"></div>
      <div class="modal-con">
        <div class="modal-con-main" v-loading="loading">
          <div class="m-header">
            <span>确认操作</span>
            <span class="iconfont icon-guanbi" @click="isModalShow = !isModalShow"></span>
          </div>
          <div class="m-content">
            <div class="zf-txt" v-if="isPass">
              请确认 <span class="zf-name">{{rowList[index].name}}</span>已通过面试 并支付 <span class="zf-yuan">{{rowList[index].carsubsidy}}元面试车补</span>给他吗？
            </div>
            <div class="zf-txt" v-if="!isPass">
              您确认 <span class="zf-name">{{rowList[index].name}}</span>不合适吗？您将支付 <span class="zf-yuan">{{rowList[index].carsubsidy}}元面试车补</span>给他吗？
            </div>
            <div class="zf-yems">
              账户余额：<span class="zf-ye">{{availableFunds}}元</span>
            </div>
            <div class="zf-zftxt" style="position: relative;">
              <p>请输入支付密码</p>
              <p v-if="passwordError" style="position: absolute; top: 0; right: 0; color: #dc1010; font-size: 14px;">
                请输入支付密码
              </p>
            </div>
            <input autocomplete="new-password"
                   style="font-size: 14px;"
                   v-model="password"
                   maxlength="20"
                   class="zf-input" ref="passwordType"/>
          </div>
          <div class="m-grpups">
            <div class="m-cancel-button" @click="isModalShow = !isModalShow">下次再说</div>
            <div class="m-confirm-button" @click="payInterview">确认支付</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NoData from '../../components/NoData.vue';
  import resumeItem from '../../components/resumeItem.vue';
  import NewConfirm from "../../components/NewConfirm.vue";

  const qs = require('qs');
  const checkListInfo = {
    0: ['批量不通过'] // '批量约面试'
  };

  export default {
    data() {
      return {
        pageNum: 1,
        pageSize: 10,
        tabName: '新收到的简历',
        tabindex: 0,
        tabList: [
          { name: '新收到的简历', id: 0, resumeType: 10 },
          { name: '待约面(原已下载)', id: 1, resumeType: 20 },
          { name: '已约面', id: 2, resumeType: 30 },
          { name: '已通过', id: 4, resumeType: 40 },
          { name: '不合适', id: 3, resumeType: 50 },
          { name: '收藏的简历', id: 6, resumeType: 60 },
        ],
        rowList: [],
        pageTotal: -1,
        isModalShow: false,
        password: '',
        passwordType: 'text',
        loading: true,
        availableFunds: 0,
        passwordError: '',
        index: 0,
        isPass: true,
        checkAll: false,
        isIndeterminate: false,
        checkedIdList: [],
        keyword: '',
        resumeType: 10,
        fullLoading: null,
        showAddResume: false,
        addResumeId: '',
        addResumeRecruitId: '',
        addResumeName: '',
      }
    },
    created() {
      const index = this.$route.query.index || 0;
      this.tabindex = Number(index);
      const obj = this.tabList.find(i => i.id === this.tabindex);
      this.rowList = [];
      this.pageTotal = 0;
      this.pageNum = 1;
      this.keyword = '';
      this.tabName = obj.name;
      this.resumeType = obj.resumeType;
      this.selTabEvents(index);
      this.resetCheckInfo();
    },
    computed: {
      checkList() {
        return checkListInfo[this.tabindex] || [];
      }
    },
    watch: {
      password(newval) {
        let k = this.$refs.passwordType;
        if (newval.length > 0) {
          k.type = 'password';
        } else {
          k.type = 'txt';
        }
      },
      isModalShow() {
        this.password = '';
      }
    },
    components: {
      resumeItem,
      NewConfirm,
      NoData
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val;
        this.selTabEvents(this.tabindex);
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.selTabEvents(this.tabindex);
      },
      handleClick(type) {
        const obj = this.tabList.find(i => i.name === type.name);
        this.rowList = [];
        this.tabName = type.name;
        this.pageTotal = 0;
        this.tabindex = obj.id;
        this.pageNum = 1;
        this.keyword = '';
        this.resumeType = obj.resumeType;
        this.selTabEvents(obj.id);
        this.resetCheckInfo();
      },
      search() {
        this.rowList = [];
        this.pageTotal = 0;
        this.pageNum = 1;
        this.selTabEvents(this.tabindex);
        this.resetCheckInfo();
      },
      resetCheckInfo() {
        this.checkedIdList = [];
        this.checkAll = false;
        this.isIndeterminate = false;
      },
      getRemain() {
        this.axios.get('/wapi/company/getRemain').then(res => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          this.availableFunds = res.data.availableFunds;
        });
      },
      // 分页切换
      handleCurrent(val) {
        this.pageNum = val;
        this.selTabEvents(this.tabindex);
      },
      // 收到的简历列表
      pageDelivered() {
        this.fullLoading = this.$loading();
        let url = `/wapi/hr/resume/pageDelivered?pageNum=${this.pageNum}&pageSize=${this.pageSize}&keyword=${this.keyword}`;
        this.axios.get(url).then(res => {
          this.fullLoading.close();
          this.rowList = res.rows;
          this.pageTotal = res.total;
        });
      },
      // 待面试列表
      pageResumeList() {
        this.fullLoading = this.$loading();
        let url = `/wapi/hr/resume/list`;
        this.axios.post(url, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          keyword: this.keyword,
          resumeType: this.resumeType
        }).then(res => {
          this.fullLoading.close();
          this.rowList = res.rows;
          this.pageTotal = res.total;
        });
      },
      // 通过/带上岗列表
      pageWaitPost() {
        this.fullLoading = this.$loading();
        let url = `/wapi/hr/resume/pageWaitPost?pageNum=${this.pageNum}&pageSize=${this.pageSize}&keyword=${this.keyword}`;
        this.axios.get(url).then(res => {
          this.fullLoading.close();
          this.rowList = res.rows;
          this.pageTotal = res.total;
        });
      },
      // 不通过不合适列表
      pageFailed() {
        this.fullLoading = this.$loading();
        let url = `/wapi/hr/resume/pageFailed?pageNum=${this.pageNum}&pageSize=${this.pageSize}&keyword=${this.keyword}`;
        this.axios.get(url).then(res => {
          this.fullLoading.close();
          this.rowList = res.rows;
          this.pageTotal = res.total;
        });
      },
      // 已上岗列表
      pageSuccess() {
        this.fullLoading = this.$loading();
        let url = `/wapi/hr/resume/pageSuccess?pageNum=${this.pageNum}&pageSize=${this.pageSize}&keyword=${this.keyword}`;
        this.axios.get(url).then(res => {
          this.fullLoading.close();
          this.rowList = res.rows;
          this.pageTotal = res.total;
        });
      },
      // 已下载简历
      pageCollWorker() {
        this.fullLoading = this.$loading();
        let url = `/wapi/hr/pageCollWorker?pageNum=${this.pageNum}&pageSize=${this.pageSize}&keyword=${this.keyword}`;
        this.axios.get(url).then(res => {
          this.fullLoading.close();
          this.rowList = res.rows;
          this.pageTotal = res.total;
        });
      },
      // 收藏的简历
      pageCollect() {
        this.fullLoading = this.$loading();
        let url = `/wapi/favorites/list`;
        this.axios.post(url, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          keyword: this.keyword
        }).then(res => {
          this.fullLoading.close();
          this.rowList = res.rows;
          this.pageTotal = res.total;
        });
      },
      // 收藏待处理的简历
      pageCollectAndNoProcess() {
        this.fullLoading = this.$loading();
        let url = `/wapi/hr/resume/list`;
        this.axios.post(url, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          resumeType: 60
        }).then(res => {
          this.fullLoading.close();
          this.rowList = res.rows;
          this.pageTotal = res.total;
        });
      },
      selTabEvents(index) {
        if (index === 6) {
          this.pageCollect();
        } else {
          this.pageResumeList();
        }
      },
      failPost(id) {
        let self = this;
        self.$ztxConfirm('确认面试者未上岗吗？', '未上岗').then(() => {
          let url = `/wapi/hr/resume/failPost?workerDeliverId=${id}`;
          self.axios.get(url).then(res => {
            if (res.success) {
              self.$message({
                type: 'success',
                message: '操作成功'
              });
              self.pageResumeList();
            }
          });
        }).catch();
      },
      successPost(id) {
        let url = `/wapi/hr/resume/successPost?workerDeliverId=${id}`;
        this.axios.get(url).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.pageResumeList();
          }
        });
      },
      // 查看详情
      goinfo(id) {
        this.$router.push({ path: '/index/resume/info', query: { workerDeliverId: id } });
      },
      // 不通过
      qppRejectInterview(id) {
        let self = this;
        self.$ztxConfirm('确认该面试者不合适吗？', '简历初审').then(() => {
          let url = `/wapi/hr/resume/fail`;
          self.axios.post(url, {
            workerDeliverId: id
          }).then(res => {
            if (res.success) {
              self.$message('操作成功');
              self.selTabEvents(self.tabindex);
            }
          });
        }).catch();
      },
      // 下载简历
      qppCollWorkerInterview(workerId, recruitId) {
        const self = this;
        const url = `/wapi/hr/collWorker?workerId=${workerId}&recruitId=${recruitId}`;
        self.axios.get(url).then(res => {
          if (res.success) {
            self.$message('操作成功');
            self.selTabEvents(self.tabindex);
          }
        });
      },
      downloadResume(id, isAdd, name, recruitId) {
        if (isAdd * 1 > 0) {
          return;
        }
        this.showAddResume = true;
        this.addResumeId = id;
        this.addResumeRecruitId = recruitId;
        this.addResumeName = name;
      },
      // 已上岗
      appInterviewSuccess(id) {
        let self = this;
        self.$ztxConfirm('确认该候选人已通过面试，并且实际已上岗。', '确认已上岗').then(() => {
          let url = `/wapi/hr/resume/success?workerDeliverId=${id}`;
          self.axios.get(url, {
            workerDeliverId: id
          }).then(res => {
            if (res.success) {
              self.$message('操作成功');
              self.selTabEvents(self.tabindex);
            }
          });
        }).catch();
      },
      payInterview() {
        let url = `/wapi/hr/resume/successView`;
        if (!this.isPass) {
          url = '/wapi/hr/resume/failView';
        }
        if (this.password.length === 0) {
          this.passwordError = '请输入支付密码';
          return;
        }
        let qdata = {
          workerDeliverId: this.rowList[this.index].id,
          password: this.password
        };
        this.loading = true;
        this.axios.post(url, qs.stringify(qdata)).then(res => {
          setTimeout(() => {
            this.loading = false;
          }, 300);
          if (res.success) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.password = '';
            this.isModalShow = false;
            this.pageResumeList();
          }
        });
      },
      interviewPass(index) {
        this.index = index;
        let iscar = this.rowList[index].provideCarsubsidy;
        if (iscar === 0) {
          let url = `/wapi/hr/resume/successView?workerDeliverId=${this.rowList[index].id}`;
          this.axios.get(url).then(() => {
            this.$message({
              type: 'success',
              message: '已约面试'
            });
            this.pageResumeList();
          });
        } else {
          this.isModalShow = true;
          this.getRemain();
          this.isPass = true;
        }
      },
      // 面试者失败
      interviewReject(index) {
        let self = this;
        self.index = index;
        let iscar = self.rowList[index].provideCarsubsidy;
        if (iscar === 0) {
          self.$ztxConfirm('确认该面试者不通过吗', '面试失败').then(() => {
            let url = `/wapi/hr/resume/failView?workerDeliverId=${self.rowList[index].id}`;
            self.axios.get(url).then(res => {
              if (res.success) {
                self.$message({
                  type: 'success',
                  message: res.msg
                });
                self.pageResumeList();
              }
            });
          }).catch();
        } else {
          self.isModalShow = true;
          self.getRemain();
          self.isPass = false;
        }
      },
      // 面试不通过
      interviewFailView(id) {
        let self = this;
        self.$ztxConfirm('确认该候选人未通过面试，信息也会同步告知。', '面试不通过').then(() => {
          const url = '/wapi/hr/resume/failView';
          const formData = new FormData();
          formData.append('workerDeliverId', id);
          self.axios.post(url, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then(res => {
            if (res.success) {
              self.$message('操作成功');
              self.selTabEvents(self.tabindex);
            }
          });
        }).catch();
      },
      // 约面试
      appInterview(id) {
        let url = `/wapi/hr/resume/gotoView?workerDeliverId=${id}`;
        this.axios.get(url).then(res => {
          if (res.success) {
            this.$message('操作成功');
            this.pageResumeList();
          }
        });
      },
      // 删除面试者
      deleteInterview(id) {
        let url = `/wapi/hr/resume/delete?workerDeliverId=${id}`;
        this.$ztxConfirm('此操作将删除该面试者, 是否继续?', '删除面试者', { isredbtn: true }).then(() => {
          this.axios.get(url).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.pageResumeList();
            }
          });
        }).catch();
      },
      // 批量操作
      handleCheckAllChange(event) {
        const complateList = this.rowList.map(v => v.id);
        this.checkedIdList = event.target.checked ? complateList : [];
        this.isIndeterminate = false;
      },
      handleCheckedidList(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.rowList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.rowList.length;
      },
      handleBatch(type) {
        // ['批量不通过', '批量约面试']
        console.log(this.tabindex);
        if (this.tabindex === 0) {
          if (type === '批量不通过') {
            this.batchQppRejectInterview();
          } else if (type === '批量约面试') {
            this.batchAppInterview();
          }
        }
      },
      // 批量不通过
      batchQppRejectInterview() {
        let self = this;
        self.$ztxConfirm('确认所有选择的面试者不合适吗？', '简历初审').then(() => {
          let url = `/wapi/hr/resume/fail`;
          self.axios.post(url, {
            workerDeliverIdList: self.checkedIdList
          }).then(res => {
            if (res.success) {
              self.$message('操作成功');
              self.pageResumeList();
              self.resetCheckInfo();
            }
          });
        }).catch();
      },
      // 批量约面试
      batchAppInterview() {
        const formData = new FormData();
        formData.append('workerDeliverIdList', this.checkedIdList);
        const params = new URLSearchParams(formData);
        let url = `/wapi/hr/resume/gotoView?${params.toString()}`;
        this.axios.get(url).then(res => {
          if (res.success) {
            this.$message('操作成功');
            this.pageResumeList();
            this.resetCheckInfo();
          }
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  @import url('../../assets/less/base.less');
  @import "../../assets/css/resume";

  .cont-top {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .tanbox-txt {
    overflow: hidden;
    float: left;
  }

  .tanbox-inp, .tanbox-inp1 {
    float: left;
    border: 1px solid #ccc;
    margin-left: 10px;
  }

  .tanbox-money {
    color: @orange;
    font-size: 16px;
    margin: 0 4px;
  }

  .modal {
    animation-duration: .3s;

    .modal-mask {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: .5;
      background: #000;
      z-index: 2004;
    }

    .modal-con {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: center;
      z-index: 2005;

      &::after {
        content: "";
        display: inline-block;
        height: 100%;
        width: 0;
        vertical-align: middle;
      }
    }

    .modal-con-main {
      text-align: left;
      display: inline-block;
      vertical-align: middle;
      background-color: #fff;
      width: 500px;
      height: 375px;
      border-radius: 3px;
      font-size: 16px;
      overflow: hidden;
      backface-visibility: hidden;

      .m-header {
        position: relative;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        background-color: @blue;
        color: #fff;

        .iconfont {
          position: absolute;
          font-size: 14px;
          right: 25px;
          cursor: pointer;
        }
      }

      .m-content {
        width: 440px;
        margin: 0 auto;
        color: #666;
      }

      .zf-txt {
        color: #666;
        font-size: 16px;
        margin-top: 23px;
        margin-bottom: 25px;

        .zf-name {
          color: #495fcd;
          margin: 0 2px 0 4px;
        }

        .zf-yuan {
          color: #ff6511;
        }
      }

      .zf-yems {
        color: #666;
        padding-bottom: 25px;
        border-bottom: 1px dashed #e5e5e5;

        span {
          color: #ff6511;
        }
      }

      .zf-zftxt {
        margin-top: 25px;
        margin-bottom: 5px;
      }

      .zf-input {
        width: 100%;
        height: 40px;
        outline: none;
        border: 1px solid #ccc;
        border-radius: 5px;

        &:focus {
          border-color: #495fcd;
        }
      }

      .m-grpups {
        float: right;
        overflow: hidden;
        padding: 33px 0;

        div {
          width: 140px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 20px;
          float: left;
          margin-right: 30px;
          font-size: 14px;
          cursor: pointer;
        }

        .m-cancel-button {
          border: 1px solid #666;
          color: #666;
        }

        .m-confirm-button {
          border: 1px solid #ff6511;
          color: #fff;
          background-color: #ff6511;
        }
      }

    }
  }

  /deep/ .c-el-checkbox {
    width: 100% !important;

    .el-checkbox {
      display: flex;
      align-items: center;
      width: 100%;

      .el-checkbox__label {
        width: 100%;
      }
    }

    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }
  }

  .checked-all-box {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    > * {
      margin-right: 20px;
    }
  }

  .el-select .el-input {
    width: 130px;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .ccc {
    display: flex;
    align-items: flex-start;

    .input-with-select {
      width: 250px;
      margin-left: 30px;

      /deep/ .el-input__inner {

      }

      /deep/ .el-icon-el-icon-search {
        color: red;
        font-size: 20px;
        width: 100%;
        height: 100%;
      }
    }

    .el-icon-search {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// list.vue?1948115f